
export const publicConfig = {
  requestUrl:  process.env.NODE_ENV == 'development' ? 'https://wellspring-dev.westwell-research.com' : '', // pro  http://172.16.10.60:8301
  
  // https://wellspring-dev.westwell-research.com dev
  //192.168.110.101:32361  lei.zhang
  // requestUrl: 'http://welldbtesting.awaymeet.com:8301', // testing
  //requestUrl: 'http://192.168.108.103:18301', // VPN testing
  // ChuanyuMa submitted and built at 2020.03.08.11.14 11:25
  // requestUrl: 'http://192.168.116.98:8301', // dev内网
  // requestUrl: 'http://welldbdev.vaiwan.com', // dev内网穿透
  commonTitle: '后稷',
  cloudFileUrl: 'https://dfs.westwell-research.com',
  //timeout: 20000
}
document.title = '数据平台-非结构化数据平台'

